import { Toaster } from "@/components/ui/toaster";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClientInstance } from "@/lib/query-client";
import { pagesConfig } from "./pages.config";
import { Routes, Route } from "react-router-dom";
import PageNotFound from "./lib/PageNotFound";
import { AuthProvider, useAuth } from "./lib/AuthContext";

const { Pages, Layout, mainPage } = pagesConfig;
const mainPageKey = mainPage ?? Object.keys(Pages)[0];
const MainPage = mainPageKey ? Pages[mainPageKey] : <></>;

const LayoutWrapper = ({ children, currentPageName }) =>
  Layout ? (
    <Layout currentPageName={currentPageName}>{children}</Layout>
  ) : (
    <>{children}</>
  );

function DefaultPage() {
  const { isAuthenticated, isLoadingAuth } = useAuth();
  const resolvedPageName = isAuthenticated ? 'Home' : mainPageKey;
  const ResolvedPage = isAuthenticated ? Pages['Home'] : Pages[mainPageKey];

  if (isLoadingAuth) {
    return null;
  }

  return (
    <LayoutWrapper currentPageName={resolvedPageName}>
      <ResolvedPage />
    </LayoutWrapper>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClientInstance}>
      <AuthProvider>
        <Routes>
        <Route
          path="/"
          element={<DefaultPage />}
        />
        {Object.entries(Pages).map(([path, Page]) => (
          <Route
            key={path}
            path={`/${path}`}
            element={
              <LayoutWrapper currentPageName={path}>
                <Page />
              </LayoutWrapper>
            }
          />
        ))}
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
